<template>
  <div class="footer">
    <p class="catchprize">Give You A New Light</p>
    <p class="catchprize-2">새로운 빛을 선물합니다</p>
  </div>
</template>
<script>
export default {};
</script>
<style>
* {
  margin: 0;
}
.footer {
  width: 100%;
  background-color: #4b74ff;
  margin: 0px;
  padding: 20px 20px 20px 0;
}
.catchprize {
  height: 46px;
  font-family: NanumBarunGothicOTF;
  font-size: 40px;
  text-align: right;
  color: #fcfcfc;
}
.catchprize-2 {
  height: 23px;
  opacity: 0.5;
  font-family: NanumBarunGothicUltraLightOTF;
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: right;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue